var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.classObj,attrs:{"disabled":_vm.disabled || _vm.loading || _vm.isEmi,"loading":_vm.loading,"aria-label":"Add To Cart","role":"button"},on:{"click":_vm.addOrRemove}},[_vm._t("default",function(){return [(_vm.disabled)?_c('span',[_vm._v("Added In Cart")]):_c('span',{domProps:{"textContent":_vm._s(_vm.$t('Add To Cart'))}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }